import React, { useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Navbar, NavItem, Nav, NavbarToggler, Collapse } from 'reactstrap';
import { compose, withHandlers, withState } from 'recompose';
import { NotificationContainer } from 'react-notifications';
import './vendor';
import { clearToken, loggedIn, decodeToken } from './services/Auth';
import Routes from './routes';
import NavLinks from './nav';

const enhance = compose(
  withRouter,
  withState('collapsed', 'setCollapsed', true),
  withHandlers({
    logout: ({ history }) => e => {
      e.preventDefault();
      clearToken();
      history.push('/login');
    },
    toggleNavbar: ({ collapsed, setCollapsed }) => () => {
      setCollapsed(!collapsed);
    },
  })
);

export const App = ({ logout, toggleNavbar, collapsed, location }) => {
  const isLoggedIn = loggedIn();
  const token = decodeToken();
  const role = token ? token.role : null;
  const resetPassword = token ? token.reset_password : false;
  let name = token && token.username;
  if (token && token.first_name) {
    if (token.last_name) {
      name = `${token.first_name} ${token.last_name}`;
    } else {
      name = token.first_name;
    }
  }

  useEffect(() => {
    // Save current location to session storage, used to reset stored search filters when navigating away from orders page
    const excludeOrder = location.pathname.includes('orders') ||  location.pathname.includes('manage-job');
    if (!excludeOrder) {
      sessionStorage.setItem('location', location.pathname);
    }
  }, [location]);

  return (
    <div>
      <NotificationContainer />
      <Navbar color="faded" light expand="md">
        <Link className="navbar-brand" to="/">
          <img src="/logo.png" alt="Logo" style={{ height: 60, width: 200 }} />
        </Link>
        <NavbarToggler onClick={toggleNavbar} />
        <Collapse className="navbar-toggleable-md mt-4" isOpen={!collapsed} navbar>
          {isLoggedIn && [
            <NavLinks key="leftNav" role={role} location={location} />,
            <Nav navbar key="rightNav">
              <NavItem>
                <Link to="/profile" className="nav-link">
                  {name}
                  &nbsp;
                  <span className="fa fa-user" />
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/logout" onClick={logout} className="nav-link">
                  Logout
                </Link>
              </NavItem>
            </Nav>,
          ]}
        </Collapse>
      </Navbar>
      <Routes role={role} resetPassword={resetPassword} />
    </div>
  );
};

export default enhance(App);



// WEBPACK FOOTER //
// ./src/App.jsx